// extracted by mini-css-extract-plugin
export default {"modal-container":"EmailModal_modal-container__yLbru","modal-window":"EmailModal_modal-window__TAQKp","modal-window-text":"EmailModal_modal-window-text__wlxTD"};